import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', this.handleAssigneeChange.bind(this))
  }

  handleAssigneeChange(event) {
    const selectedUserId = event.target.value
    
    // Add visual feedback
    this.element.classList.add('animate-pulse')
    
    setTimeout(() => {
      this.element.classList.remove('animate-pulse')
    }, 300)

    // Dispatch custom event for other controllers to listen to
    this.dispatch('assigneeChanged', { 
      detail: { 
        userId: selectedUserId,
        userName: event.target.options[event.target.selectedIndex].text
      } 
    })
  }
}
